import initialState from './state';

const setManualEvaluationId = (state, id) => {
  state.manualEvaluationId = id;
};

const setIncome = (state, { income, summary, incomeCardSummary, totalIncomeCardSummary }) => {
  state.income = income;
  state.incomeSummary = summary;
  state.incomeCardSummary = incomeCardSummary;
  state.totalIncomeCardSummary = totalIncomeCardSummary;
};

const setIncomeAmount = (state, amount) => {
  state.incomeCardSummary.income.children[0].label = amount;
};

const setDebt = (state, { debt, summary, debtCardSummary, totalDebtCardSummary }) => {
  state.debt = debt;
  state.debtSummary = summary;
  state.debtCardSummary = debtCardSummary;
  state.totalDebtCardSummary = totalDebtCardSummary;
};

const setSimulation = (state, simulation) => {
  if (!simulation) {
    state.simulation = {
      generalParams: {
        country: 'CL',
        creditType: '',
        ufDate: '',
        purchaseDate: '',
        insuranceableValue: 0,
        hasRealEstate: false,
        hasAddress: false
      },
      offerParams: {
        purpose: '',
        segment: {
          name: '',
          purpose: ''
        }
      },
      offerResponse: {
        propertyValue: 0,
        creditAmount: 0,
        credituAmount: 0,
        amountRequestedByClient: 0,
        approvedAmount: 0,
        approvedAmountFinanceCharge: 0,
        approvedAmountIncomeDividend: 0,
        approvedAmountLoanToValue: 0,
        financingAmount: 0,
        backEndRatio: 0,
        frontEndRatio: 0,
        loanToValueHome: 0,
        financingRatio: 0,
        creditInsuranceFee: 0,
        lifeInsuranceFee: 0,
        propertyInsuranceFee: 0,
        titleStudyExpenses: 0,
        appraisalExpenses: 0,
        deedExpenses: 0,
        notaryExpenses: 0,
        registrationExpenses: 0,
        creditTaxExpenses: 0,
        operationalExpensesFinanced: 0,
        operationalExpensesFee: 0,
        operationalExpenses: 0
      },
      ipcaValue: 0,
      offerInputs: {
        propertyType: '',
        isPropertyNew: false,
        property: {
          address: {
            mainLine: '',
            secondaryLine: '',
            city: '',
            country: ''
          }
        },
        realEstate: {
          id: null,
          name: '',
          other: false,
          project: {
            id: null,
            name: '',
            deliveryDate: null,
            fromQRCode: false
          },
          agreement: []
        },
        district: '',
        downPayment: 0,
        subsidy: 0,
        numberOfMonths: 0,
        numberOfGraceMonths: 0,
        useDoublePayments: false,
        purchaseDate: 'notDefined'
      },
      prospect: {
        hasCodebtor: false
      },
      createdAt: ''
    };
    return;
  }

  state.simulation = {
    generalParams: {
      country: 'CL',
      creditType: 'MORTAGE',
      ufDate: simulation.createdAt, // Validar trae fecha de creación evaluación, puede ser actual
      purchaseDate: simulation.offerInputs.purchaseDate,
      insuranceableValue: simulation.offerParams.creditInsuranceFinancing,
      hasRealEstate: !!(simulation.offerInputs.realEstate && simulation.offerInputs.realEstate.name),
      hasAddress: !!(simulation.offerInputs.property && simulation.offerInputs.property.address && simulation.offerInputs.property.address.mainLine)
    },
    offerParams: {
      purpose: simulation.offerParams.purpose,
      amortizationMethod: simulation.offerParams.amortizationMethod,
      annualInterestRate: simulation.offerParams.annualInterestRate,
      creditInsuranceRate: simulation.offerParams.creditInsuranceRate,
      isCreditInsuranceAccelerated: simulation.offerParams.isCreditInsuranceAccelerated,
      maximumCreditLTV: simulation.offerParams.maximumCreditLTV,
      segment: simulation.offerParams.segment,
      subSegment: simulation.offerParams.subSegment,
      maximumBackendRatio: simulation.offerParams.maximumBackendRatio,
      maximumFrontendRatio: simulation.offerParams.maximumFrontendRatio,
      maximumPropertyLTV: simulation.offerParams.maximumPropertyLTV,
      creditMaxAmount: simulation.offerParams.creditMaxAmount,
      creditMinAmount: simulation.offerParams.creditMinAmount,
      interestType: simulation.offerParams.interestType,
      taxRate: simulation.offerParams.taxRate,
      creditInsurancePercentageFinanced: simulation.offerParams.creditInsurancePercentageFinanced,
      creditInsuranceNumberOfMonths: simulation.offerParams.creditInsuranceNumberOfMonths,
      creditInsuranceFeeTermDefinition: simulation.offerParams.creditInsuranceFeeTermDefinition,
      propertyInsuranceMonthlyRate: simulation.offerParams.propertyInsuranceMonthlyRate,
      unemploymentInsuranceMonthlyRate: simulation.offerParams.unemploymentInsuranceMonthlyRate,
      subsidyRate: simulation.offerParams.subsidyRate,
      lifeInsuranceTypeOfPremium: simulation.offerParams.lifeInsuranceTypeOfPremium,
      investmentWeight: simulation.offerParams.investmentWeight,
      propertyTypeFactor: simulation.offerParams.propertyTypeFactor,
      titleStudyExpenses: simulation.offerParams.titleStudyExpenses,
      appraisalExpenses: simulation.offerParams.appraisalExpenses,
      deedExpenses: simulation.offerParams.deedExpenses,
      notaryExpenses: simulation.offerParams.notaryExpenses,
      realEstateExpensesRate: simulation.offerParams.realEstateExpensesRate,
      creditTaxRate: simulation.offerParams.creditTaxRate,
      titleStudyExpensesPercentage: simulation.offerParams.titleStudyExpensesPercentage,
      appraisalExpensesPercentage: simulation.offerParams.appraisalExpensesPercentage,
      deedExpensesPercentage: simulation.offerParams.deedExpensesPercentage,
      notaryExpensesPercentage: simulation.offerParams.notaryExpensesPercentage,
      realEstateExpensesRatePercentage: simulation.offerParams.realEstateExpensesRatePercentage,
      creditTaxRatePercentage: simulation.offerParams.creditTaxRatePercentage,
      graceMonthsInterestMethod: simulation.offerParams.graceMonthsInterestMethod,
      realEstateExpensesPercentage: simulation.offerParams.realEstateExpensesPercentage,
      lifeInsuranceDebtorMonthlyRateRanges: simulation.offerParams.lifeInsuranceDebtorMonthlyRateRanges,
      lifeInsuranceCodebtorMonthlyRateRanges: simulation.offerParams.lifeInsuranceCodebtorMonthlyRateRanges
    },
    segment: simulation.offerParams.segment || '', // Usado en front, no esta en endpoint
    subSegment: simulation.offerParams.subSegment,
    offerInputs: {
      propertyType: simulation.offerInputs.propertyType,
      isPropertyNew: simulation.offerInputs.isPropertyNew,
      district: simulation.offerInputs.district || '',
      property: { // No está en endpoint
        address: {
          mainLine: simulation.offerInputs.property?.address?.mainLine || '',
          secondaryLine: simulation.offerInputs.property?.address?.secondaryLine || '',
          city: simulation.offerInputs.property?.address?.city || '',
          country: simulation.offerInputs.property?.address?.country || ''
        }
      },
      downPayment: simulation.offerInputs.downPayment,
      subsidy: simulation.offerInputs.subsidy,
      numberOfMonths: simulation.offerInputs.numberOfMonths,
      commercialValue: simulation.offerInputs.commercialValue,
      appraisal: simulation.offerInputs.appraisal,
      numberOfCodebtors: simulation.offerInputs.numberOfCodebtors,
      numberOfGraceMonths: simulation.offerInputs.numberOfGraceMonths,
      operationalExpensesFinancing: simulation.offerInputs.operationalExpensesFinancing,
      purchaseDate: simulation.offerInputs.purchaseDate,
      secondaryCurrencyFactor: simulation.offerInputs.secondaryCurrencyFactor,
      realEstate: { // Con Inmobiliaria
        id: simulation.offerInputs.realEstate?.id || null,
        name: simulation.offerInputs.realEstate?.name || '',
        other: simulation.offerInputs.realEstate?.other || false,
        project: {
          id: simulation.offerInputs.realEstate?.project?.id || null,
          name: simulation.offerInputs.realEstate?.project?.name || '',
          deliveryDate: simulation.offerInputs.realEstate?.project?.deliveryDate || null,
          fromQRCode: simulation.offerInputs.realEstate?.project?.fromQRCode || false
        },
        agreement: simulation.offerInputs.realEstate?.agreement || []
      },
      codebtorIncome: simulation.offerInputs.codebtorIncome,
      useDoublePayments: simulation.offerInputs.useDoublePayments,
      disposableIncome: simulation.offerInputs.disposableIncome,
      prospectIncome: simulation.offerInputs.prospectIncome,
      shortTermMonthlyFee: simulation.offerInputs.shortTermMonthlyFee,
      longTermMonthlyFee: simulation.offerInputs.longTermMonthlyFee
    },
    offerResponse: {
      propertyValue: simulation.offerResponse.propertyValue, // No esta en endpoint
      creditAmount: Number(simulation.offerResponse.creditAmount).toFixed(4),
      credituAmount: Number(simulation.offerResponse.credituAmount).toFixed(4),
      amountRequestedByClient: Number(simulation.offerResponse.amountRequestedByClient).toFixed(4),
      approvedAmount: Number(simulation.offerResponse.approvedAmount).toFixed(4),
      approvedAmountFinanceCharge: Number(simulation.offerResponse.approvedAmountFinanceCharge).toFixed(4),
      approvedAmountIncomeDividend: Number(simulation.offerResponse.approvedAmountIncomeDividend).toFixed(4),
      approvedAmountLoanToValue: simulation.offerResponse.approvedAmountLoanToValue,
      financingAmount: Number(simulation.offerResponse.financingAmount).toFixed(4),
      backEndRatio: simulation.offerResponse.backEndRatio,
      frontEndRatio: simulation.offerResponse.frontEndRatio,
      loanToValueHome: simulation.offerResponse.loanToValueHome,
      financingRatio: simulation.offerResponse.financingRatio,
      creditInsuranceFee: Number(simulation.offerResponse.creditInsuranceFee).toFixed(4),
      lifeInsuranceFee: Number(simulation.offerResponse.lifeInsuranceFee).toFixed(4),
      propertyInsuranceFee: Number(simulation.offerResponse.propertyInsuranceFee).toFixed(4),
      unemploymentInsuranceFee: Number(simulation.offerResponse.unemploymentInsuranceFee).toFixed(4),
      titleStudyExpenses: simulation.offerResponse.titleStudyExpenses,
      appraisalExpenses: simulation.offerResponse.appraisalExpenses,
      deedExpenses: simulation.offerResponse.deedExpenses,
      notaryExpenses: simulation.offerResponse.notaryExpenses,
      registrationExpenses: simulation.offerResponse.registrationExpenses,
      creditTaxExpenses: simulation.offerResponse.creditTaxExpenses,
      operationalExpensesFinanced: simulation.offerResponse.operationalExpensesFinanced,
      operationalExpensesFee: simulation.offerResponse.operationalExpensesFee,
      operationalExpenses: simulation.offerResponse.operationalExpenses
    },
    ipcaValue: simulation.ipcaValue,
    amortizationSchedule: simulation.amortizationSchedule,
    amortizationScheduleRows: simulation.amortizationSchedule.amortizationScheduleRows || [],
    prospect: {
      hasCodebtor: simulation.prospect.hasCodebtor
    },
    createdAt: simulation.createdAt
  };
};

const setInitialData = (state, { idNumber, userId, parentEvaluationId, simulation }) => {
  state.idNumber = idNumber;
  state.userId = userId;
  state.parentEvaluationId = parentEvaluationId;

  setSimulation(state, simulation);
};

const setEligibilityData = (state, { eligibilityData, eligibilityType, eligibilityParams = null }) => {
  state.eligibilityData = eligibilityData;
  state.eligibilityType = eligibilityType;
  if (eligibilityParams) {
    state.eligibilityParams = eligibilityParams;
  }
};
const setEligibilityResult = (state, eligibilityResult) => {
  state.eligibilityResult = eligibilityResult;
};

const setEvaluationParams = (state, evaluationParams) => {
  state.idNumber = evaluationParams.idNumber;
  state.userId = evaluationParams.userId;
  state.parentEvaluationId = evaluationParams.parentEvaluationId;
  state.eligibility = evaluationParams.eligibility;
  state.income = evaluationParams.income.calculate;
  state.debt = evaluationParams.debt.calculate;
  state.evaluationType = evaluationParams.evaluationType;
};

const setDebtor = (state, debtor) => {
  state.debtor = debtor;
};

const resetState = state => {
  // Asigna el estado inicial
  Object.assign(state, initialState());
};
export default {
  setManualEvaluationId,
  setIncome,
  setIncomeAmount,
  setDebt,
  setSimulation,
  setInitialData,
  setEligibilityData,
  setEligibilityResult,
  setEvaluationParams,
  setDebtor,
  resetState
};
